import {
  AdminClient,
  BrokerAccountsClient,
  BrokerConnectionsClient,
  CorporateActionsClient,
  DashboardClient,
  FxClient,
  InstrumentsClient,
  PortfolioGroupsClient,
  PortfoliosClient,
  TransactionsClient,
  WatchlistsClient,
} from "./generated/api-client-generated";
import { httpClient } from "./http-client";

const sameOriginBaseUrl = "";

export const adminClient = new AdminClient(sameOriginBaseUrl, httpClient);
export const brokerAccountsClient = new BrokerAccountsClient(sameOriginBaseUrl, httpClient);
export const brokerConnectionsClient = new BrokerConnectionsClient(sameOriginBaseUrl, httpClient);
export const corporateActionsClient = new CorporateActionsClient(sameOriginBaseUrl, httpClient);
export const dashboardClient = new DashboardClient(sameOriginBaseUrl, httpClient);
export const fxClient = new FxClient(sameOriginBaseUrl, httpClient);
export const instrumentsClient = new InstrumentsClient(sameOriginBaseUrl, httpClient);
export const portfolioGroupsClient = new PortfolioGroupsClient(sameOriginBaseUrl, httpClient);
export const portfoliosClient =new PortfoliosClient(sameOriginBaseUrl, httpClient);
export const transactionsClient = new TransactionsClient(sameOriginBaseUrl, httpClient);
export const watchlistsClient = new WatchlistsClient(sameOriginBaseUrl, httpClient);
